import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import Modal from '../../controls/Modal';
import LabeledInput from '../../controls/LabeledInput';
import AppMediaList from '../../controls/media/AppMediaList';

// Модалка редактирования перехода Дозора: номер, название, описание, медиа.
export default function TransitionModal({ transitionId, dozorState, onClose }) {
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState(null);
    const [media, setMedia] = useState([]);
    const [pending, setPending] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        dozorState.loadTransitionDetails(transitionId).then(d => {
            if (!mounted) return;
            setData({ title: d.title || '', orderId: d.orderId || 1, description: d.description || '' });
            setMedia(d.mediaList || []);
            setLoading(false);
        }).catch(() => { if (mounted) { enqueueSnackbar('Ошибка при загрузке данных перехода', { variant: 'error' }); setLoading(false); } });
        return () => { mounted = false; };
    }, [transitionId, dozorState, enqueueSnackbar]);

    const set = (field, value) => setData(prev => ({ ...prev, [field]: value }));

    const save = async () => {
        try {
            const existing = media.filter(it => !it.__pending);
            await dozorState.saveTransition(transitionId, { ...data, mediaList: existing }, pending);
            setPending([]);
            onClose();
        } catch (e) { /* ошибку покажет хук */ }
    };
    const del = async () => { onClose(); await dozorState.deleteTransition(transitionId); };

    if (loading || !data) {
        return <Modal open title="Переход" onClose={onClose}><div className="vp-empty">Загрузка…</div></Modal>;
    }

    const footer = (
        <>
            <button type="button" className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={del}>Удалить</button>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
            <button type="button" className="btn btn-primary" onClick={save}>Сохранить</button>
        </>
    );

    return (
        <Modal open kicker="Переход" title="Редактирование перехода" size="lg" onClose={onClose} footer={footer}>
            <div className="fr-grid2">
                <LabeledInput label="Номер" value={String(data.orderId)} onChange={(e) => set('orderId', e.target.value)} />
                <LabeledInput label="Название перехода" value={data.title} onChange={(e) => set('title', e.target.value)} />
            </div>
            <div>
                <label className="ctl-label">Описание перехода (для организаторов)</label>
                <textarea className="textarea" value={data.description} onChange={(e) => set('description', e.target.value)} />
            </div>
            <div>
                <div className="section-label">Медиа</div>
                <AppMediaList value={media} pendingFiles={pending} onChange={(v, p) => { setMedia(v); setPending(p); }} type="ALL" />
            </div>
        </Modal>
    );
}

TransitionModal.propTypes = {
    transitionId: PropTypes.number.isRequired,
    dozorState: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};
